<template>
  <span class="p_badge label label-danger js-tooltip" style="background-color: red" data-title="Extra prontuario"> X </span>
</template>
<script>
export default {
  name: 'xLabel',
};
</script>
